import styles from "./PrivatecollegeAccreditation.module.css";

interface Data {
  card: {
    title: string;
    description: string;
  };
  seta_list: {
    title: string;
    list: listItem[];
  };
  associations_list: {
    title: string;
    list: listItem[];
  };
}

interface listItem {
  id: number;
  item: string;
}

interface PrivatecollegeAccreditationProps {
  data: Data;
}

export const PrivatecollegeAccreditation: React.FC<
  PrivatecollegeAccreditationProps
> = ({ data }) => {
  return (
    <div className={`container ${styles.collegeRow}`}>
      <h3 className={styles.heading}>{data?.card?.title}</h3>
      <p className={styles.registration}>{data?.card?.description}</p>

      <div className={styles.content}>
        <div className={styles.column}>
          <h3>{data?.seta_list?.title}</h3>
          <ul>
            {data?.seta_list?.list.map((item) => (
              <li key={item?.id}>{item?.item}</li>
            ))}
          </ul>
        </div>
        <div className={styles.column}>
          <h3>{data?.associations_list?.title}</h3>
          <ul>
            {data?.associations_list?.list.map((item) => (
              <li key={item?.id}>{item?.item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
